import * as React from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {ApplicationState} from "../../store";
import {
	actionUserFetchByResetPasswordToken,
	actionUserResetPasswordRequest,
	actionUserResetPasswordRequestReset
} from "../../store/global";
import {withStyles} from "@material-ui/core/styles";
import {GlobalStyles} from "../../materialui/style";
import {CircularProgress, FormControl, FormHelperText, Link, TextField} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {t} from "../../core/localization";
import {AppConfig} from "../../config";
import LogBox from "../../core/logger/LogBox";
import {PopupDialog} from "../../core/components/PopupDialog";

export interface ResetPasswordPageProps {
	loading: number;
	match: any;
	resetPasswordUser: any;
	resetPasswordUserError: boolean;
	resetPasswordError: boolean;
	resetPasswordCompleted: boolean;
	history: any
}

export interface ResetPasswordPageState {
	newPassword: string,
	repeatedPassword: string,
	resetPasswordUserError: boolean,
	resetPasswordUserErrorMessage: string,
	resetPasswordError: boolean,
	resetPasswordErrorMessage: string,
}

function mapStateToProps(state: ApplicationState) {
	return {
		loading: state.global.loading,
		resetPasswordUser: state.global.resetPasswordUser,
		resetPasswordUserError: state.global.resetPasswordUserError,
		resetPasswordError: state.global.resetPasswordError,
		resetPasswordCompleted: state.global.resetPasswordCompleted
	};
}

class ResetPasswordPage extends React.Component<ResetPasswordPageProps, ResetPasswordPageState>  {

	constructor(props: ResetPasswordPageProps) {
		super(props);
		this.state = {
			newPassword: '',
			repeatedPassword: '',
			resetPasswordUserError: false,
			resetPasswordUserErrorMessage: '',
			resetPasswordError: false,
			resetPasswordErrorMessage: ''
		};
	}

	componentDidMount(): void {

		const token = this.props.match.params.token;

		if(token) {
			this.loadData(this.props.match.params.token);
		}

		if(this.props.resetPasswordUserError) {
			this.setState({resetPasswordUserError: true, resetPasswordUserErrorMessage: t.InvalidToken})
		}
	}

	componentDidUpdate(prevProps: Readonly<ResetPasswordPageProps>, prevState: Readonly<ResetPasswordPageState>, snapshot?: any): void {

		let token = prevProps.match.params.token;
		if(prevProps.match.params.token !== this.props.match.params.token) {
			token = this.props.match.params.token
			this.loadData(token);
		}

		if(this.props.resetPasswordUserError !== prevProps.resetPasswordUserError) {

			const resetPasswordUserErrorMessage = this.props.resetPasswordUserError ? t.InvalidToken : '';

			this.setState({resetPasswordUserError: this.props.resetPasswordUserError, resetPasswordUserErrorMessage: resetPasswordUserErrorMessage})
		}
	}

	render(): React.ReactNode {

		return (
			<div className="desktop-app">
				{AppConfig().logging && <LogBox />}
				{(this.props.loading > 0) &&
				<div className="opacityOverlay">
					<div className="loadingOverlay">
						<CircularProgress />
					</div></div>}
				{this.renderContent()}
			</div>
		);
	}

	renderContent(): React.ReactNode {

		return this.state.resetPasswordUserError ? this.renderUserErrorMessage() : this.renderResetPasswordForm();
	}

	renderUserErrorMessage(): React.ReactNode {
		return <div className={'ev-login'} style={{position: 'fixed', top: '30%', left: '25%', width: '50%'}}>
			<h1 style={{color: '#ed1a3a'}}>{t.InvalidToken}</h1>
			<p>{t.ResetPasswordTokenExpiredMessage}</p>
			<p>{t.TryResettingPasswordAgainMessage}</p>
			<a onClick={() => this.props.history.push('/')} style={{color: '#ed1a3a'}}>{t.BackToLogin}</a>
		</div>
	}

	renderResetPasswordForm(): React.ReactNode {
		return <div className={'ev-login'} style={{position: 'fixed', top: '30%', left: '25%', width: '50%'}}>
			<h1 style={{color: '#ed1a3a'}}>{t.EnterNewPassword}</h1>
			<FormControl style={{width: '100%'}}>
				<TextField
					label="New password"
					onChange={(e) => {this.setState({...this.state, newPassword: e.target.value})}}
					value={this.state.newPassword}
					margin="normal"
					type='password'
					fullWidth
					required={true}
					error={this.state.resetPasswordError}
				/>
				<TextField
					label="Repeat password"
					onChange={(e) => {this.setState({...this.state, repeatedPassword: e.target.value})}}
					value={this.state.repeatedPassword}
					margin="normal"
					type='password'
					fullWidth
					required={true}
					error={this.state.resetPasswordError}
				/>
			</FormControl>
			{this.state.resetPasswordError && <FormHelperText style={{color: '#ed1a3a'}}>{this.state.resetPasswordErrorMessage}</FormHelperText>}
			<Button onClick={this.onResetPasswordClick.bind(this)} variant="contained" color="primary" style={{marginTop: '20px'}}>{t.Change}</Button>
			<PopupDialog
				isOpen={this.props.resetPasswordCompleted && !this.props.resetPasswordError}
				title={t.Success}
				text={t.ResetPasswordMessage}
				onClose={this.onResetPasswordConfirmDialogClose.bind(this)} />
		</div>
	}

	loadData(token: string) {
		actionUserFetchByResetPasswordToken(token)
	}

	onResetPasswordClick() {

		let { newPassword, repeatedPassword } = this.state

		if(newPassword === '' || repeatedPassword === '') {
			this.setState({resetPasswordError: true, resetPasswordErrorMessage: t.RequiredFields});
			return;
		}

		if(newPassword !== repeatedPassword) {
			this.setState({resetPasswordError: true, resetPasswordErrorMessage: t.NotMatchingPasswords});
			return;
		}

		actionUserResetPasswordRequest(this.props.resetPasswordUser.id, this.state.newPassword)
		this.setState({resetPasswordError: false, resetPasswordErrorMessage: ''});
	}

	onResetPasswordConfirmDialogClose() {

		actionUserResetPasswordRequestReset();

		this.setState({
			newPassword: '',
			repeatedPassword: '',
			resetPasswordUserError: true,
			resetPasswordUserErrorMessage: t.InvalidToken,
			resetPasswordError: false,
			resetPasswordErrorMessage: ''
		});

		console.log(this.props);
		//this.props.match.history.push('/');
	}
}

export default compose(
	withStyles(GlobalStyles),
	connect(mapStateToProps)
)(ResetPasswordPage);
